module.exports = __webpack_public_path__ + "static/dcom1-768x681-a038bf9a6662c0bb3ee86e429d1216a2.png";